import React from 'react'
import { string, bool } from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useContainerWidth, PersonBlock } from '@fs/zion-ui'
import { usePreference } from '@fs/zion-preferences'
import useRelationTransKey from '../../../../shared/hooks/useRelationTransKey'
import { getGender } from '../../../../shared/helpers/person_Helper'
import { getDisplayName } from '../../../../shared/helpers/name_formatting'

const PersonImage = ({ portraitThumbnailLink, children, genderType }) => {
  const atWidth = useContainerWidth()
  const src = portraitThumbnailLink ?? ''

  return (
    <>
      <PersonBlock
        size={atWidth({ default: 'xl', xsm: 'xl' })}
        name=""
        avatarProps={{ sex: getGender(genderType), src }}
      />
      {children}
    </>
  )
}
export default function SliderProfileImage({ needsFormatting, ...relation }) {
  const [t] = useTranslation()
  const relationTransKey = useRelationTransKey(relation)
  const showRoman = usePreference('tree.showNamesInRomanScript')
  const orderedName = getDisplayName(relation, showRoman)
  const formattedName = needsFormatting && orderedName.length > 14 ? `${orderedName.slice(0, 13)}...` : orderedName

  return (
    <PersonImage {...relation}>
      <div className={relation.isActive ? 'details active' : 'details'}>
        <div className="name">{formattedName}</div>
        <div className="relation">{relationTransKey ? t(`wcf.person-header.relation.${relationTransKey}`) : ''}</div>
      </div>
    </PersonImage>
  )
}
SliderProfileImage.propTypes = {
  gender: string,
  portraitThumbnailLink: string,
  needsFormatting: bool,
}
